<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select
            placeholder="Realice una consulta..."
            @search="searchVendedores"
            label="descripcion"
            id="vendedor"
            name="vendedor"
            @input="inputVendedor"
            v-model="selectedVendedor"
            :options="vendedoresExistentes"
          ></v-select>
          <label for="vendedor">Vendedor</label>
        </div>
      </div>
    </div>
    <div class="col-xs-12">
      <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th>Vendedor</th>
              <th>Dirección</th>
              <th>Teléfono(s)</th>
              <th>Correo(s)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(vendedor, index) in vendedores" :key="index">
              <td>
                {{ vendedor.descripcion }}
              </td>
              <td>
                {{ vendedor.direccion }}
              </td>
              <td>
                {{ vendedor.telefonos }}
              </td>
              <td>
                {{ vendedor.correos }}
              </td>
              <td>
                <button
                  @click="eliminar(index)"
                  type="button"
                  class="btn-danger btn--text"
                >
                  <i class="fa fa-times"></i>
                </button>
              </td>
            </tr>
            <tr v-show="vendedores.length == 0">
              <td colspan="5">
                <strong>No se ha agregado vendedores.</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    inputVendedor: function () {
      if (this.selectedVendedor != null) {
        let existe = false;
        for (let i = 0; i < this.vendedores.length; i++) {
          if (this.vendedores[i].id == this.selectedVendedor.id) {
            existe = true;
            break;
          }
        }
        if (!existe)
          this.vendedores.push({
            descripcion: this.selectedVendedor.descripcion,
            direccion: this.selectedVendedor.direccion,
            telefonos: this.selectedVendedor.telefonos,
            correos: this.selectedVendedor.correos,
            id: this.selectedVendedor.id,
          });
        setTimeout(() => {
          this.selectedVendedor = null;
        }, 500);
      }
    },
    eliminar: function (index) {
      this.vendedores.splice(index, 1);
    },
    searchVendedores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.vendedoresExistentes = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
      xmlhttp.send();
    },
  },
  data: function () {
    return {
      vendedoresExistentes: [],
      selectedVendedor: null,
      vendedores: this.value,
    };
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/rutas/VendedoresRuta.vue